export default __webpack_public_path__ + "static/media/pizzaResp.80bb8225.jpg";